import { useState } from 'react'

import configurationServices from '@/configuration/services/services'

import { blockImageSettingKey, blockImageUploadStatuses } from './constants'
import { getImageSize, withBlockStatus } from './helpers'

const useBlockImageUpload = ({ storeId, updateBlockSetting, resizeBlock }) => {
  const [blockStates, setBlockStates] = useState({})

  const uploadBlockImage = async (blockId, file) => {
    setBlockStates(previous => withBlockStatus(previous, blockId, blockImageUploadStatuses.loading))

    const formData = new FormData()
    formData.append('image', file)

    try {
      const [{ data }, imageSize] = await Promise.all([
        configurationServices.uploadOrderTrackingImage({ storeId, formData }),
        getImageSize(file),
      ])

      setBlockStates(previous => withBlockStatus(previous, blockId, blockImageUploadStatuses.idle))
      updateBlockSetting(blockId, blockImageSettingKey, data.image)

      if (imageSize) resizeBlock(blockId, imageSize)

      return data.image
    } catch {
      setBlockStates(previous => withBlockStatus(previous, blockId, blockImageUploadStatuses.error))

      return null
    }
  }

  return { blockStates, uploadBlockImage }
}

export default useBlockImageUpload
